import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

const sizes = [
    'big',
    'small',
    'tiny',
];

const colors = [
    'blue',
    'red',
    'yellow',
    'green',
];

const positions = [
    'left',
    'right',
];

const Spinner = ({size, active, ...props}) => (
    <div className={classNames('preloader-wrapper', size, {active})} {...props}>
        {colors.map(color => <SpinnerLayer color={color} key={color} />)}
    </div>
);

Spinner.propTypes = {
    size: PropTypes.oneOf(sizes),
    active: PropTypes.bool,
};

Spinner.defaultProps = {
    size: null,
    active: true,
};

const SpinnerLayer = ({color}) => (
    <div className={classNames('spinner-layer', `spinner-${color}`)}>
        <CircleClipper pos="left" />
        <GapPatch />
        <CircleClipper pos="right" />
    </div>
);

SpinnerLayer.propTypes = {
    color: PropTypes.oneOf(colors).isRequired,
};

const CircleClipper = ({pos}) => (
    <div className={classNames('circle-clipper', pos)}>
        <Circle />
    </div>
);

CircleClipper.propTypes = {
    pos: PropTypes.oneOf(positions).isRequired,
};

const GapPatch = () => (
    <div className="gap-patch">
        <Circle />
    </div>
);

const Circle = () => (
    <div className="circle" />
);

export default Spinner;



// WEBPACK FOOTER //
// ./scripts/components/Spinner.js